import React from "react";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import { staticPagesTabsData } from "../../../../data/SidebarData";
import Tabs from "../../../../Components/Common/Tabs";
import StaticContactForm from "../StaticContact/Components/StaticContactForm";

const StaticPrivacyPolicy = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={staticPagesTabsData} />
      <StaticContactForm
        title="Privacy Policies"
        customSlug="privacy-policies"
        includeSocialLinks={false}
      />
    </div>
  );
};

export default StaticPrivacyPolicy;


